import { render, staticRenderFns } from "./CharacterItemPreview.vue?vue&type=template&id=36f1aaff&scoped=true&"
import script from "./CharacterItemPreview.vue?vue&type=script&lang=js&"
export * from "./CharacterItemPreview.vue?vue&type=script&lang=js&"
import style0 from "./CharacterItemPreview.vue?vue&type=style&index=0&id=36f1aaff&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f1aaff",
  null
  
)

export default component.exports